<div class="login-wrapper">
    <div id="sign-in-widget"></div>
</div>
